import isEmpty from "lodash/isEmpty";
import { MisalignmentsDetailSidePanelContent } from "PFApp/booking/components/details_panel/detail_view/misalignments_detail_side_panel/misalignments_detail_side_panel_content";
import { LoadingDots } from "PFComponents/loading_dots";
import SidePanel from "PFComponents/side_panel/side_panel";
import { memo, useRef } from "react";

import { DetailsSidePanelProps } from "../../details_panel_item";
import { MisalignmentsHeader } from "./misalignments_header";
import { useMisalignmentsData } from "./use_misalignments_data";

export const MisalignmentsDetailSidePanel = memo(
  ({
    isOnTop,
    show,
    data,
    onClose,
    zIndex,
    isClosing,
    disableEntranceAnimation = false
  }: DetailsSidePanelProps) => {
    const sidePanelRef = useRef<HTMLDivElement>(null);

    const { activities, profiles, warningsByActivity, isLoading } = useMisalignmentsData(data);

    return (
      <SidePanel
        rootRef={sidePanelRef}
        show={show}
        zIndex={zIndex}
        isSidePanelClosing={isClosing}
        onClose={onClose}
        title={!isLoading ? <MisalignmentsHeader activities={activities} /> : null}
        isOnTop={isOnTop}
        disableEntranceAnimation={disableEntranceAnimation}
      >
        {isLoading && <LoadingDots />}
        {!isEmpty(activities) && (
          <MisalignmentsDetailSidePanelContent
            data={data}
            sidePanelRef={sidePanelRef}
            activities={activities}
            profiles={profiles}
            warningsByActivity={warningsByActivity}
          />
        )}
      </SidePanel>
    );
  }
);

MisalignmentsDetailSidePanel.displayName = "MisalignmentsDetailSidePanel";
